import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const Header = () => {
    const [isNavToggle, setIsNavToggle] = useState(false);
    const [isProductsDropdownOpen, setIsProductsDropdownOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            if (isProductsDropdownOpen) {
                setIsProductsDropdownOpen(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isProductsDropdownOpen]);

    const handleToggleNav = () => {
        setIsNavToggle((toggle) => !toggle);

        if (isNavToggle) {
            document.body.style.overflow = "auto";
        } else {
            document.body.style.overflow = "hidden";
        }
    };

    const handleProductsDropdownToggle = () => {
        setIsProductsDropdownOpen((prev) => !prev);
    };

    return (
        <header className={`header ${isNavToggle ? "mobile-menu" : ""}`}>
            <div className="container">
                <nav className="nav">
                    <a href="/" className="nav__logo">
                        <img src="/images/logo.svg" alt="Logo" />
                    </a>

                    <button
                        className={`navbar-toggler ${
                            isNavToggle ? "change" : ""
                        }`}
                        onClick={handleToggleNav}
                    >
                        <div className="toggler-btn">
                            <span className="bar bar1"></span>
                            <span className="bar bar2"></span>
                            <span className="bar bar3"></span>
                        </div>
                    </button>

                    <ul className="nav__links">
                        <li className="nav__link-item nav__link-item--dropdown">
                            <button 
                                className={`nav__link nav__link--dropdown ${location.pathname === "/" ? "nav__link--active" : ""}`}
                                onClick={handleProductsDropdownToggle}
                            >
                                Products
                                <span className={`dropdown-arrow ${isProductsDropdownOpen ? 'dropdown-arrow--open' : ''}`}>▼</span>
                            </button>
                            
                            {isProductsDropdownOpen && (
                                <div className="nav__dropdown">
                                    <div className="nav__dropdown-content">
                                        <div className="nav__dropdown-section">
                                            <h3 className="nav__dropdown-title"></h3>
                                            <div className="nav__dropdown-items">
                                                <div className="nav__dropdown-item">
                                                    <a href="/katalife-free" className="nav__dropdown-link">
                                                        <strong>KataLife Free</strong>
                                                        <p>For Individuals and small businesses up to 3 users</p>
                                                    </a>
                                                </div>
                                                
                                                 <div className="nav__dropdown-item"  >
                                                    <a href="https://business.kata.life" className="nav__dropdown-link">
                                                        <strong>Katalife Professional</strong>
                                                        <p>For medium sized teams and Businesses up to 100 users </p>
                                                    </a>
                                                </div> 
                                                {/*
                                                <div className="nav__dropdown-item">
                                                    <a href="/katalife-organisation" className="nav__dropdown-link">
                                                        <strong>Katalife Premium</strong>
                                                        <p>For organisations who want to use branding and track organisation level feedback.</p>
                                                    </a>
                                                </div>
                                                */}
                                            </div>
                                        </div>
                                        
                                        <div className="nav__dropdown-section">
                                            <h3 className="nav__dropdown-title">Use Cases</h3>
                                            <div className="nav__dropdown-items">
                                                <div className="nav__dropdown-item">
                                                    <a href="usecase-hospitality" className="nav__dropdown-link">
                                                        <strong>Hospitality Customer Feedback</strong>
                                                    </a>
                                                </div>
                                                {/* 
                                                <div className="nav__dropdown-item">
                                                    <a href="/360-feedback" className="nav__dropdown-link">
                                                        <strong>360 Feedback</strong>
                                                    </a>
                                                </div>
                                                <div className="nav__dropdown-item">
                                                    <a href="/hospitality-feedback" className="nav__dropdown-link">
                                                        <strong>Hospitality Customer Feedback</strong>
                                                    </a>
                                                </div>
                                                <div className="nav__dropdown-item">
                                                    <a href="/accounting-feedback" className="nav__dropdown-link">
                                                        <strong>Accounting Service Feedback</strong>
                                                    </a>
                                                </div>
                                                <div className="nav__dropdown-item">
                                                    <a href="/tradie-feedback" className="nav__dropdown-link">
                                                        <strong>Tradie Service Customer Feedback</strong>
                                                    </a>
                                                </div>
                                                */}
                                            </div>
                                        </div>
                                    </div>                                                                        
                                </div>
                            )}
                        </li>

                        <li className="nav__link-item">
                            <a href="/pricing" className={`nav__link ${location.pathname === "/pricing" ? "nav__link--active" : ""}`}>
                                Pricing
                            </a>
                        </li>
                        <li className="nav__link-item">
                            <a target="_blank" href="https://www.youtube.com/@KatatechSupport/videos" className="nav__link">
                                Youtube
                            </a>
                        </li>
                        <li className="nav__link-item"></li>
                        <li className="nav__link-item">
                            <a target="_blank"  href="https://calendly.com/katatech-support/30min" className="nav__link">
                                Book a Demo
                            </a>
                        </li>
                        <li className="nav__link-item">
                            <a href="https://app.kata.life" className="nav__link nav__link--login">
                                Login
                            </a>
                        </li>
                        <li className="nav__link-item">
                            <a href="https://app.kata.life/signup" className="nav__link nav__link--signup">
                                Sign up free
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;
